<template>
  <fragment>
    <slot v-bind="{ moment }" v-if="hasDefaultSlot" />
    <span v-else>{{ renderDate() }}</span>
  </fragment>
</template>

<script>
// Dependencies
import * as moment from "moment";
import { Fragment } from "vue-fragment";
import { default as mixins } from "../../mixins";

// Custom date format for danish
moment.updateLocale("da", {
  longDateFormat: {
    L: "DD/MM/YYYY",
    l: "D/M/YYYY"
  }
});

// Export Vue component
export default {
  components: { Fragment },
  props: {
    date: {
      type: [Number, String],
      default: Date.now()
    },
    format: {
      type: String,
      default: "LLL"
    },
    relative: {
      type: Boolean,
      default: false
    },
    calendar: {
      type: Boolean,
      default: false
    },
    dateOnly: {
      type: Boolean,
      default: false
    },
    withTime: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasDefaultSlot() {
      return !!this.$scopedSlots.default;
    },
    moment() {
      return moment;
    }
  },
  methods: {
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    $t(key) {
      return mixins.$t(key, `components.date.${key}`);
    },
    isCurrentYear(date) {
      return date.year() == moment().year();
    },
    getTimeFormat(date) {
      if (this.dateOnly) return "";
      if (this.withTime) {
        return " LT";
      } else {
        return "";
      }
    },
    renderCalendarDate(date) {
      const timeFormat = this.getTimeFormat(date);
      let dateFormat = `L${timeFormat}`;

      // Custom format for Danish locale
      if (date.locale() === "da") {
        dateFormat = this.isCurrentYear(date) ? "D. MMM." : "DD/MM/YYYY";
      }

      return this.capitalize(
        date.calendar(null, {
          lastDay: `[${this.$t("yesterday")}], LT`,
          sameDay: `[${this.$t("today")}], LT`,
          nextDay: `[${this.$t("tomorrow")}], LT`,
          lastWeek: dateFormat,
          nextWeek: dateFormat,
          sameElse: dateFormat
        })
      ).trim();
    },
    getFormat(locale) {
      return this.format;
    },
    renderDate() {
      // Make sure Epoch / Unix is handled as number
      const normalized = /^\d+$/.test(this.date)
        ? Number(this.date)
        : this.date;

      // Prepare moment instance
      const date = moment(normalized);

      // Set locale
      const locale =
        typeof window !== "undefined" && window.CLIENT && window.CLIENT.locale;
      date.locale(locale || "da");

      // Handle relative time
      if (this.relative) {
        return this.capitalize(date.fromNow());
      }

      // Handle calendar time
      if (this.calendar) {
        return this.renderCalendarDate(date);
      }

      // Return format
      return date.format(this.getFormat(date.locale()));
    }
  }
};
</script>
